import React from 'react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from 'react-router-dom';
import store, { persistor } from './redux/store';
import { ScrollPositionProvider } from './utilities/scroll-position-context';
import App from './App';
import { getEnvironmentMode } from './config/env-config';
import { googleCaptcha } from './constants';

const root = createRoot(document.getElementById('root'));
const environmentMode = getEnvironmentMode();
const googleCaptchKey = environmentMode === ('tcp' || 'tcpehs' || 'omya' || 'pror' || 'uflex' || 'adani' || 'tcpsop') ? googleCaptcha?.PROD_SITE_KEY : googleCaptcha?.STG_SITE_KEY;

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      {/* <React.StrictMode> */}
      <Router>
        <ScrollPositionProvider>
          <GoogleReCaptchaProvider reCaptchaKey={googleCaptchKey}>
            <App />
          </GoogleReCaptchaProvider>
        </ScrollPositionProvider>
      </Router>
      {/* </React.StrictMode> */}
    </PersistGate>
  </Provider>,
);
